module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=LK - Sri Lanka.fa4683b6.svg";